import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-up",
  templateUrl: "./med-icon-arrow-up.component.html",
})
export class MedIconArrowUpComponent extends SvgMixinComponent {}
